import { BadgeStatus } from '@cas/components/data-display/badge-dot/BadgeDot';
import { useTranslation } from 'react-i18next';
import { ReportingStatus } from '@customer/store/apis/assetsApi';
import { ReactElement, useMemo } from 'react';
import StatusCell from '@cas/components/data-display/status-cell/StatusCell';

interface ReportingStatusCellRendererProps {
  value: ReportingStatus;
}

export function ReportingStatusCellRenderer({
  value,
}: ReportingStatusCellRendererProps): ReactElement {
  const { t } = useTranslation();

  const [label, status] = useMemo(() => {
    switch (value) {
      case ReportingStatus.Bad:
        return [t('ReportingStatusBad'), BadgeStatus.Danger];
      case ReportingStatus.Moderate:
        return [t('ReportingStatusModerate'), BadgeStatus.Caution];
      case ReportingStatus.Good:
        return [t('ReportingStatusGood'), BadgeStatus.Healthy];
    }
  }, [value, t]);

  return <StatusCell label={label} status={status} />;
}

export default ReportingStatusCellRenderer;
